export default __webpack_public_path__ + "static/media/bath1.e5cc098a.jpg";